module.exports = __webpack_public_path__ + "cf869f38201c012f1f5efeea9d92ab1a.png";